// VN label map for the 17 report column codes — QC bug: technical
// snake_case headers (plan_code, quantity_required, mix_status, etc.)
// confuse KH. Lookup table; falls back to the raw code if a new column
// lands without a translation (graceful, never crashes).
//
// Filter codes used by the dynamic Input row also share this map.

export const REPORT_COLUMN_LABELS: Record<string, string> = {
  // Common
  full_name: 'Họ tên',
  phone: 'SĐT',
  email: 'Email',
  gender: 'Giới tính',
  year_of_birth: 'Năm sinh',
  birthday: 'Ngày sinh',
  status: 'Trạng thái',
  category: 'Loại',
  note: 'Ghi chú',
  created_by: 'Người tạo',
  creator: 'Người tạo',
  manager: 'Quản lý',
  source: 'Nguồn',
  area: 'Khu vực',
  month: 'Tháng',
  from_date: 'Từ ngày',
  to_date: 'Đến ngày',
  opened_at: 'Mở lúc',
  resolved_at: 'Xử lý xong',
  added_at: 'Thêm lúc',
  approved_by: 'Người duyệt',
  duration_h: 'Thời gian xử lý (giờ)',
  occurred_at: 'Thời điểm',
  // Plan / campaign
  plan_code: 'Mã chiến dịch',
  plan_id: 'Mã chiến dịch',
  plan_name: 'Tên chiến dịch',
  customer: 'Khách hàng',
  customer_id: 'Mã KH',
  quantity_required: 'Chỉ tiêu',
  quantity_hired: 'Đã nhận',
  qualified_count: 'Đủ điều kiện',
  completion_rate_pct: 'Hoàn thành (%)',
  rate_pct: 'Tỉ lệ (%)',
  start_date: 'Ngày bắt đầu',
  end_date: 'Ngày kết thúc',
  // Worker
  worker_id: 'Mã NLĐ',
  worker_code: 'Mã NLĐ',
  factory: 'Nhà máy',
  factory_id: 'Mã nhà máy',
  academic_level: 'Trình độ',
  mix_status: 'Trạng thái tổng hợp',
  work_start_date: 'Ngày vào làm',
  // Team / NV TD
  team: 'Team',
  team_id: 'Mã team',
  nv_td: 'NV tuyển dụng',
  // Attendance
  total_days: 'Tổng công',
  np_count: 'Nghỉ phép',
  nkp_count: 'Nghỉ không phép',
  nld_days: 'NLĐ chấm',
  qld_days: 'QLĐ chấm',
  final_days: 'Công chuẩn',
  // Leave
  type: 'Loại đơn',
  type_code: 'Loại đơn',
  // Violation
  violation_group: 'Nhóm lỗi',
  severity: 'Mức độ',
  violations: 'Số vi phạm',
  // Payroll
  hours: 'Số giờ',
  amount: 'Số tiền',
  code: 'Mã',
  label: 'Tên',
  service_group: 'Nhóm dịch vụ',
  total_hours: 'Tổng giờ',
  rate_per_hour: 'Đơn giá/giờ',
  total_amount: 'Tổng tiền',
  // Funnel (RP-12)
  step: 'Bước',
  count: 'Số lượng',
  pct_of_top: '% / Bước 1',
  benchmark_pct: 'Benchmark (%)',
  delta: 'Chênh lệch',
  // RP-13 perf
  target: 'Chỉ tiêu',
  data_added: 'Data đã thêm',
  data_arrived: 'Data đã đến',
  conversion_pct: 'Conversion (%)',
  completion_pct: 'Hoàn thành (%)',
  // RP-14 dashboard
  key: 'Mục',
  value: 'Giá trị',
  // RP-15 survey
  survey_id: 'Mã KS',
  title: 'Tên KS',
  ok_count: 'OK',
  ko_count: 'Không OK',
  auto_ok_count: 'Auto OK',
  pending_count: 'Chờ',
  // RP-16 ticket
  ticket_id: 'Mã ticket',
  // RP-17
  data_type: 'Loại data',
  pct: 'Tỉ lệ (%)',
  compliance_score: 'Điểm tuân thủ',
  // Filter labels (cũng dùng cho input filter chips)
  user_id: 'Người dùng',
  creator_id: 'Người tạo',
  from: 'Từ ngày',
  to: 'Đến ngày',
};

// Totals card label map (RP-16 cards primarily)
export const REPORT_TOTAL_LABELS: Record<string, string> = {
  total: 'Tổng',
  resolved: 'Đã giải quyết',
  in_progress: 'Đang xử lý',
  overdue: 'Quá hạn',
  total_workers: 'Tổng NLĐ',
};

export function colLabel(code: string): string {
  return REPORT_COLUMN_LABELS[code] ?? code;
}

export function totalLabel(code: string): string {
  return REPORT_TOTAL_LABELS[code] ?? code;
}
